import React from 'react';

import { Box, Text, TextProps } from '@opendoor/bricks/core';
import { InternalLink } from 'platform/react-router';
import { getHubBuyingFeedFiltersRoute } from 'shared/helpers/routes';
import { generateSummary } from 'buying/helpers/offerDash/generateFeedSummaryText';

import { PropertiesFilterFragment as PropertiesFilter } from 'buying/graphql/fragments/__generated__/PropertiesFilterFragment';

interface PropertyFiltersSummaryProps extends TextProps {
  propertyFilters?: PropertiesFilter;
  onEditFeedClick?: () => void;
}

/**
 * Renders a summary of the user's OLA feed filters
 *
 * storybook-check-ignore
 */
export const PropertyFiltersSummary: React.FC<PropertyFiltersSummaryProps> = ({
  propertyFilters,
  onEditFeedClick,
  ...rest
}) => {
  const summary = propertyFilters && generateSummary(propertyFilters);
  if (!summary) {
    return null;
  }

  return (
    <Text size="s0" {...rest} data-testid="property-filter-summary">
      <Box as="span" mr={2}>
        {summary}{' '}
      </Box>
      <InternalLink
        to={getHubBuyingFeedFiltersRoute()}
        analyticsName="property-filters-summary-edit-feed"
        aria-label="Edit filters"
        fontWeight="semibold"
        whiteSpace="nowrap"
        onClick={() => {
          onEditFeedClick && onEditFeedClick();
        }}
      >
        Edit filters
      </InternalLink>
    </Text>
  );
};
